import {
	Select, Text, Number, CheckBox,
	FormGroupInterface, FORM_TYPE, VALIDATION_TYPE,TableActions,Upload
} from 'projects/common/src/app/types';

interface IOptionRequired {
	areaAvailability?: any[];
	fireFightingEquipmentAvailability?: any[];
}
interface ResidentialFacility {
	typeOfConstructionBuilding: any[];
	areaAvailability: any[];
	houseKeepingStaff: any[];
	meals: any[]
	menuList?: any[],
	partitionsMadeOf?: any[];
	// wallsOfResidentials?: any[];
	// floorOfTheResidentials?: any[];
}
export function basicIfo(data: any = {}, savedFormData: any = {}, on: any = {}) {
	const basicInfoForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: 'Facilities at Centre:',

				formElements: [
					new Select(
						'Type of Building of the Training Centre',
						data.buildingStatus || [],
						{
							required: true,
							placeholder: 'Select the Type of Building of the Training Centre',
							value: savedFormData.general && savedFormData.general.buildingStatus,
							labelDiv: 4,
							inputDiv: 8,
							name: 'buildingStatus',
							asyncLoad: true,
							readOnly:true,
							onChange:on.buildingStatusChange
						}
					),
					new Upload('MoU:', {
						required: true,
						// remove: !fields.addressProof,
						hide:savedFormData && savedFormData.general && savedFormData.general.buildingStatus !== 'Industry premises with MoU' ,
						labelDiv: 4,
						inputDiv: 8,
						maxSize:5,
						name: 'buildingStatusDocumnet',
						readOnly:true,
						validationType: VALIDATION_TYPE.FILE,
						 value: savedFormData.general && savedFormData.general.buildingStatusUrl
					}),
					new Select(
						'Type of the Construction of Building:',
						data.typeOfConstructionBuilding || [],
						{
							required: true,
							name: 'buildingConstrictionType',
							value:
								savedFormData.general &&
								savedFormData.general.buildingConstrictionType,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly:true,
						}
					),
					new Select(
						'Proximity to Public Transport System:',
						data.proximityToPublicTransport || [],
						{
							required: true,
							name: 'proximityTOPublicTransportSystem',
							value: savedFormData.general && savedFormData.general.proximityTOPublicTransportSystem,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly: true,
						}
					),
					// new Upload('Snapshot of map showcasing the distance (b/w Tc and nearest transport system):', {
					// 	required: true,
					// 	readOnly: true,
					// 	// remove: !fields.addressProof,
					// 	labelDiv: 4,
					// 	inputDiv: 8,
					// 	maxSize:5,
					// 	name: 'proximityTOPublicTransportSystemDocument',
					// 	placeholder:'Choose File',
					// 	validationType: VALIDATION_TYPE.FILE,
					// 	value:  savedFormData.general && savedFormData.general.proximityTOPublicTransportSystemUrl
					// }),
					new Text(
						'Nearest Bus/Metro/Railway Station Name:',
						{
							placeholder: 'Enter the name of the Nearest Bus/Metro/Railway Station',
							// pattern: '^(?:[0-9]+[\s]+[0-9](?=.*[a-zA-Z])|[0-9]+[\s]+[A-Za-z]|[0-9]+[A-Za-z]|[A-Za-z])[a-zA-Z0-9 \_\s]*$',
							required: true,
							validationType: VALIDATION_TYPE.ALPHANUMERIC,
							name: 'nearestTransportName',
							value: savedFormData.general && savedFormData.general.nearestTransportName,
							maxFieldLength: 50,
							minFieldLength: 5,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true

						}
					),
					new Select(
						'Front Face of the Building',
						data.frontFaceBuilding || [],
						{
							required: true,
							placeholder: 'Select Front Face of the Building',
							name: 'frontFaceOfBuilding',
							value: savedFormData.general && savedFormData.general.frontFaceOfBuilding,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly: true
						}
					),
					new Number(
						'Approach road to Centre:',
						{
							required: true,
							placeholder: 'Enter width of Approach road of centre in feets',
							// value: data.approachRoadToCentreWidth,
							name: 'approachRoadToCentreWidth',
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							charAllowedPattern: '[0-9]',
							max: 150,
							maxFieldLength: 3,
							min: 5,
							value: savedFormData.general && savedFormData.general.approachRoadToCentreWidth,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true

						}
					),
					new Select(
						'Previous State of the Building:',
						data.previousStateOfBuilding || [],
						{
							required: true,
							placeholder: 'Select Previous State of the Building',
							name: 'previousStateOfBuilding',
							value:
								savedFormData.general &&
								savedFormData.general.previousStateOfBuilding,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly: true

						}
					),

					new CheckBox(

						'Facilities Available at the centre:',
						{
							// lineAtStart: true,
							// lineAtEnd: true,
							checkboxes: [
								{
									label: 'Security Guards',
									// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.securityGaurds,
									name: 'securityGaurds'
								},
								{
									label: 'Greenery in the surrounding',
									// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.greeneryInTheSurrounding,
									name: 'greeneryInTheSurrounding'
								},
								// {
								// 	label: 'Adequate Power Backup (UPS/GenSet/Inverter)',
								// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.adequatePowerBackup,
								// 	name: 'adequatePowerBackup'
								// },
								{
									label: 'Training Centre Functional',
									// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
									name: 'isTrainingCentreFunctional'
								}
							],
							// atLeastChecked: 2,
							onChange:on.onPowerAdequate,
							colDivision: 2,
						// 	required: true,
							name: 'trainingCentreFacilities',
							// value: savedFormData.trainingCentreFacilities,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true

						}
					),
					new CheckBox(

						'Adequate Power Backup (UPS/GenSet/Inverter):',
						{
							checkboxes: [
								{
									label: '',
									// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.biometricAttendanceSystem,
									name: 'adequatePowerBackup'
								}
							],
							onChange:on.onPowerAdequate,
							atLeastChecked: 0,
							colDivision: 2,
							// required: true,
							name: 'trainingCentreFacilities2',
						// 	value: savedFormData.trainingCentreFacilities,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true

						}
					),
					// new Upload('Ownership proof:', {
					// 	required: true,
					// 	// remove: !fields.addressProof,
					// 	labelDiv: 4,
					// 	inputDiv: 8,
					// 	maxSize: 5,
					// 	hide: true,
					// 	readOnly: true,
					// 	name: 'adequatePowerBackupUrl',
					// 	placeholder:'Choose File',
					// 	validationType: VALIDATION_TYPE.FILE,
					// 	value:  savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.adequatePowerBackupUrl
					// }),
					new CheckBox(

						'Aadhaar-Enabled Biometric Attendance System:',
						{
							checkboxes: [
								{
									label: '',
									// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.biometricAttendanceSystem,
									name: 'biometricAttendanceSystem'
								}
							],
							onChange:on.onAdharChange,
							atLeastChecked: 0,
							colDivision: 2,
							required: true,
							name: 'trainingCentreFacilities1',
						// 	value: savedFormData.trainingCentreFacilities,
							labelDiv: 4,
							inputDiv: 8,
						}
					),
					// new Upload('Bill/Purchase order (in the name of TP/TC):', {
					// 	required: true,
					// 	readOnly: true,
					// 	// remove: !fields.addressProof,
					// 	maxSize:5,
					// 	labelDiv: 4,
					// 	inputDiv: 8,
					// 	name: 'biometricAttendanceSystemURL',
					// 	placeholder:'Choose File',
					// 	validationType: VALIDATION_TYPE.FILE,
					// 	value:  savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.biometricAttendanceSystemUrl
					// 	// value: address.addressProof
					// }),
					new Select(
						'Type of Centre Floor:',
						data.typeOfCentreFloor || [],
						{
							required: true,
							readOnly: true,
							placeholder: 'Select Type of Centre Floor',
							name: 'typeOfCentreFloor',
							 value: savedFormData.general && savedFormData.general.typeOfCentreFloor,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true
						}
					),
					new Select(
						'Type of Training Centre Walls:',
						data.typeOfTrainingCentreWalls || [],
						{
							required: true,
							readOnly: true,
							placeholder: 'Select Type of Training Centre Walls',
							name: 'typeOfTrainingCentreWalls',
							 value: savedFormData.general && savedFormData.general.typeOfTrainingCentreWalls,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true
						}
					),
					new Select(
						'Availability of Internet:',
						data.availabilityOfInternet || [],
						{
							required: true,
							readOnly: true,
							placeholder: 'Select Availability of Internet',
							name: 'availabilityOfInternet',
							 value: savedFormData.general && savedFormData.general.availabilityOfInternet,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true
						}
					),
					// new Upload('Internet Bill with speed (not older than 2 months):', {
					// 	required: true,
					// 	readOnly: true,
					// 	// remove: !fields.addressProof,
					// 	labelDiv: 4,
					// 	inputDiv: 8,
					// 	maxSize: 5,
					// 	placeholder:'Choose File',
					// 	name: 'availailityOfInternetDocumnet',
					// 	validationType: VALIDATION_TYPE.FILE,
					// 	lineAtEnd:true,
					// 	value: savedFormData.general && savedFormData.general.availabilityOfInternetUrl
					// }),
				]
			}
		]
	};
	return basicInfoForm;
}
export function typeOfResidentialForms(data: any = {}, on: any = {},) {
	const typeOfResidentialForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: '',
				formElements: [
					new CheckBox(
						'Type of Residential Facility',
						{
							name: 'type',
							labelDiv: 4,
							inputDiv: 8,
							// required: true,
							checkboxes: [
								{
									label: 'Men',
									name: 'men',
								},
								{
									label: 'Women',
									name: 'women',
								},
								{
									label: 'Transgender',
									name: 'transgender',
								}
							],
							 onChange:on.typeResidential,
							colDivision: 1,
							required: true,
							readOnly: true
						}
					),
				]

			}
		]
	}
	return typeOfResidentialForm;
}
export function getForms(data: ResidentialFacility, on: any = {}, modificationInForm:any = {} ) {
	const residentialFacilitiesForm: FormGroupInterface = {
	label: 'Amenities',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: modificationInForm.label,
				formElements: [
					// new Select(
					// 	modificationInForm.subLabel,
					// 	data.areaAvailability || [
					// 		{
					// 			name: 'Yes',
					// 			value: true
					// 		},
					// 		{
					// 			name: 'No',
					// 			value: false
					// 		}
					// 	],
					// 	{
					// 		name: 'availability',
					// 		required: true,
					// 		onChange: on.onChange,
					// 		placeholder: 'Select if the Residential area Available or Not',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad:true
					// 	}
					// ),
					// new Select(
					// 	'Separate entrances for Male and Female Facility if the hostel is in the same building:',
					// 	data.areaAvailability  || [
					// 		{
					// 			name: 'Yes',
					// 			value: 'Yes'
					// 		},
					// 		{
					// 			name: 'No',
					// 			value: 'No'
					// 		},
					// 		{
					// 			name: 'Not Applicable',
					// 			value: 'Not Applicable'
					// 		}
					// 	],
					// 	{
					// 		name: 'seperateEntranceForMF',
					// 		required: modificationInForm.require,
					// 		hide:modificationInForm.hide,
					// 		placeholder: 'Select Separate entrances for Male and Female Facility if the hostel is in the same building',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad: true,
					// 		onChange: on.seperateEntranceChange,
					// 		// metainfo:'Male & Female Facilities can be on different floors of the same building but with dedicated entries'
					// 	}
					// ),
					// new Select(
					// 	'Is the Residential facility within 7 Km from Training Centre (TC):',
					// 	data.areaAvailability,
					// 	{
					// 		name: 'availabilityOfTransportSystem',
					// 		required: true,
					// 		placeholder: 'Select Is the Residential facility within 7 Km from TC',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad: true,
					// 		metainfo:'If distance from TC is greater than 1.5 Km (upto 7 Km Max.), to and fro transportation facility to be provided.'
					// 	}
					// ),



					new Select(
						modificationInForm.warden.label,
							[{
								name: 'Available',
								value: true
							},
							{
								name: 'Not Available',
								value: false
							}
						],
						{
							name: 'Warden',
							required: true,
							placeholder: modificationInForm.warden.placeholder,
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
							asyncLoad:true
						}
					),
					new CheckBox(
						'Area is equipped with:',
						{

							required: true,
							checkboxes: [
								{
									label: 'CCTV Camera with Recording Facility at the Entrance',
									name: modificationInForm.cctvLabel,
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								// {
								// 	label: 'Mess/Dinning Area',
								// 	name: 'mess',
								// },
								{
									label: 'Availability of Security Guard(s)',
									name: 'allTImeSecurity',
								},
								{
									label: 'Backup(UPS/GenSet Inverter)',
									name: 'backup',
								}
							],
							name: 'equipedWith',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							//required: true,
							atLeastChecked:3,
							colDivision: 2,
							onChange: on.onCCTVChange

						}
					),
					new Upload('Documentary Proof for CCTV camera with Recording Facility at the Entrance:', {
						required: true,
						// remove: !fields.addressProof,
						labelDiv: 4,
						inputDiv: 8,
						maxSize: 5,
						placeholder: 'Choose File',
						readOnly: true,
						name: 'cctvCameraDocumentUrl',
						onChange:on.cctvChange,
						validationType: VALIDATION_TYPE.FILE,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'docx'],
						// value: address.addressProof
					}),
					new Upload('', {
						// required: true,
						disabled: true,
						hide: true,
						readOnly: true,
						// remove: !fields.addressProof,
						labelDiv: 4,
						inputDiv: 8,
						maxSize: 5,
						placeholder: 'Choose File',
					//	documentTemplateUrl: '',
					//	isPublicUrl: true,
						name: 'previewcctvCameraDocumentUrl',
						validationType: VALIDATION_TYPE.FILE,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'docx'],
						 value: null
					}),
					// new Number(
					// 	'Distance From Training Centre:',
					// 	{
					// 		name: 'distanceFromTrainingCentre',
					// 		required: true,
					// 		maxFieldLength: 5,
					// 		min: 1,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Distance From Training Centre',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 	}
					// ),

					// new Select(
					// 	'Type of Construction:',
					// 	data.typeOfConstructionBuilding,
					// 	{
					// 		name: 'typeOfConstructionBuildingOfResidential',
					// 		required: true,
					// 		placeholder: 'Select Type of Construction of the Building of the Residential Facility',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad:true
					// 	}
					// ),

					// new Select(
					// 	'Document type for House Keeping Staff Type:',
					// 	data.houseKeepingStaff,
					// 	{
					// 		required: true,
					// 		hide:true,
					// 		placeholder: 'Select Document type for House Keeping Staff Type',
					// 		name: 'houseKeepingStaffType',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad:true
					// 	}
					// ),
					// new Upload('Documentary Proof:', {
					// 	required: true,
					// 	hide:true,
					// 	// remove: !fields.addressProof,
					// 	maxSize:5,
					// 	labelDiv: 4,
					// 	inputDiv: 8,
					// 	placeholder:'Choose File',
					// 	name: 'houseKeppingStaffUrl',
					// 	validationType: VALIDATION_TYPE.FILE,
					// 	// value: address.addressProof
					// }),

					// new CheckBox(
					// 	'Cleanliness and Hygiene Area Equipped With:',
					// 	{
					// 		name: 'equipedWith',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		// required: true,
					// 		checkboxes: [
					// 			{
					// 				label: 'Dedicated Housekeeping Staff',
					// 				name: 'dedicatedhouseKeepingStaff',
					// 			},
					// 			/*{
					// 				label: 'Warden',
					// 				name: 'warden',
					// 			},*/
					// 			{
					// 				label: 'Drinking Water in form of Reverse Osmosis(RO)/Water purifier/Packaged drinking water',
					// 				name: 'drinkingWater',
					// 			},
					// 			{
					// 				label: 'Dustbin',
					// 				name: 'dustbin',
					// 			}
					// 		],
					// 		onChange:on.onCCTVChange,
					// 		colDivision: 2,
					// 		atLeastChecked: 1
					// 	}
					// ),
					new Select(
						'Availability of First-Aid Kit:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfFirstAidKit',
							onChange:on.availabilityOfFirstAidKitChange,
							required: true,
							placeholder: 'Select Availability of First-Aid Kit',
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
							asyncLoad:true
						}
					),
					new CheckBox(
						'First-Aid Kit Equipped With:',
						{
							name: 'equippedWith',
							labelDiv: 4,
							inputDiv: 8,
							required: true,
							checkboxes: [
								{
									label: 'Emergency telephone numbers for emergency medical services',
									name: 'emergencyTelephoneNumber',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Sterile gauze pads (dressings) in small and large squares to place over wounds',
									name: 'sterileGauzePadsAvailability',
								},
								{
									label: 'Disinfectants like Dettol or Savlon',
									name: 'disinfectantslikeDettolSavlon',
								}, {
									label: 'Medicines like pain killer',
									name:'medicinesLikePainKiller'
								},
								{
									label: 'Roller bandages to hold dressings in place',
									name:'rollerBandages'
								}
								,
								{
									label: 'Adhesive tape/Adhesive bandages in assorted size',
									name:'adhesiveBandages'
								},
								{
									label: 'Scissors and Tweezers',
									name:'scissorsAndTweezers'
								}, {
									label: 'Antiseptics wipes or soap',
									name:'antisepticWipesOrSoap'
								}, {
									label: 'Thermometer',
									name:'thermometer'
								}
								, {
									label: modificationInForm.doctorLabel,
									name:'doctor'
								}
							],
							colDivision: 2,
							hide: true,
							readOnly: true,
							//disabled:true
							atLeastChecked: 10
						}
					),
					new Select(
						'Availability of Fire Fighting Equipment:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfFireFightingEquipment',
							required: true,
							placeholder: 'Select Availability of Fire Fighting Equipment',
							labelDiv: 4,
							inputDiv: 8,
							onChange: on.fireFightingEquipmentChange,
							readOnly: true,
							asyncLoad:true
						}
					),
					new CheckBox(
						'Fire Fighting Equipped With:',
						{
							name: 'fireFightingEquipedWith',
							labelDiv: 4,
							inputDiv: 8,
							required: true,
							checkboxes: [
								{
									label: 'Water based Fire Extinguisher',
									name: 'waterBasedFireExtinguisher',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Foam based Fire Extinguisher',
									name: 'foamBasedFireExtinguisher',
								},
								{
									label: 'Dry Powder based Fire Extinguisher',
									name: 'dryPowderBasedFireExtinguisher',
								}, {
									label: 'Carbon dioxide based Fire Extinguisher',
									name:'carbonDioxideBasedFireExtinguisher'
								},
								{
									label: 'Wet Checmical based Fire Extinguisher',
									name:'wetChemicalBasedFireExtinguisher'
								}

							],
							colDivision: 2,
							hide: true,
							readOnly: true,
							atLeastChecked: 1
						}
					),
					// new CheckBox(
					// 	'Availability of Aadhar Enabled Biometric Attendance System(AEBAS):',
					// 	{
					// 		name: 'AEBS',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		//  required: true,
					// 		checkboxes: [
					// 			{
					// 				label: '',
					// 				name: 'aebs',
					// 			}
					// 		],
					// 		onChange:on.biometricChange,
					// 		colDivision: 2,
					// 		// atLeastChecked: 1
					// 	}
					// ),


					new Select(
						'Contact numbers of fire brigade, hospital, ambulance are displaying in hostel common area such as reception & dinning area:',
						data.areaAvailability || [
							{
								name: 'Contact numbers of fire brigade, hospital, ambulance are displaying in hostel common area such as reception & dinning area',
								value: true
							},
							{
								name: 'Yes',
								value: false
							},{
								name: 'No',
								value: true
							}
						],
						{
							name: 'isMedicalContactNumberAvaliable',
							//onChange:on.availabilityOfDiningAreaChange,
							required: true,
							placeholder: 'Contact numbers of fire brigade, hospital, ambulance are displaying in hostel common area such as reception & dinning area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad: true,
						//	onChange:on.isMedicalContactChange
						}
					),
					// new Number(
					// 	'Contact Number:',
					// 	{
					// 		name: 'medicalContactNumber',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 10,
					// 		min: 18,
					// 		validationType: VALIDATION_TYPE.MOBILE_NUMBER,
					// 		placeholder: 'Enter the Contact Number',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		// metainfo:'Minimum of 6ft * 3ft.(L*W)'
					// 	}
					// ),
					// new Text(
					// 	'Contact number of fire brigade, hospital, ambulance displayed in hostel common area such as Reception, dining area:',
					// 	{
					// 		name: 'isMedicalContactNumberAvaliable',
					// 		lineAtEnd: false,
					// 		required: true,
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		placeholder: 'Please Mention Contact number of fire brigade, hospital, ambulance displayed in hostel common area such as Reception, dining area'
					// 	}
					// ),

					new Select(
						'Emergency Exit Directions Displayed in the common area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'isEmergencyExitDirection',
							//onChange:on.availabilityOfDiningAreaChange,
							required: true,
							placeholder: 'Select Emergency Exit Directions Displayed in the common area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					// new Select(
					// 	'Availability of Aadhar Enabled Biometric Attendance System(AEBAS):',
					// 	data.areaAvailability || [
					// 		{
					// 			name: 'Yes',
					// 			value: true
					// 		},
					// 		{
					// 			name: 'No',
					// 			value: false
					// 		}
					// 	],
					// 	{
					// 		name: 'AEBS',
					// 		//onChange:on.availabilityOfDiningAreaChange,
					// 		required: true,
					// 		placeholder: 'Select Availability of Aadhar Enabled Biometric Attendance System(AEBAS)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		asyncLoad:true
					// 	}
					// ),
					new Select(
						'Availability of Aadhar Enabled Biometric Attendance System(AEBAS):',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'AEBS',
							//onChange:on.availabilityOfDiningAreaChange,
							required: true,
							placeholder: 'Select Availability of Aadhar Enabled Biometric Attendance System(AEBAS)',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					new CheckBox(
						'Cleanliness and Hygiene Area Equipped With:',
						{
							name: 'cleanHygineEquipedWith',
							labelDiv: 4,
							inputDiv: 8,
							// required: true,
							checkboxes: [
								{
									label: 'Dedicated Housekeeping Staff',
									name: 'dedicatedHouseKeepingStaff',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Clean and Safe Drinking Water',
									name: 'drinkingWater',
								},
								{
									label: 'Dustbin',
									name: 'dustbin',
								}
							],
							onChange: on.onCleanlinessChange,
							readOnly: true,
							colDivision: 2,
							atLeastChecked: 1
						}
					),
					new CheckBox(
						'Type of Safe Drinking Water:',
						{
							name: 'cleanAndSafeDrinkingWater',
							labelDiv: 4,
							inputDiv: 8,
							required: true,
							 hide:true,
							checkboxes: [
								{
									label: 'Reverse Osmosis(RO)',
									name: 'reverseOsmosis',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Water Purifier',
									name: 'waterPurifier',
								},
								{
									label: 'Packaged Drinking Water',
									name: 'packagedDrinkingWater',
								},
								{
									label: 'Packaged Drinking Water Dispenser',
									name: 'packagedDrinkingWaterDispenser',
								}
							],
							colDivision: 2,
							atLeastChecked: 1,
							readOnly: true
						}
					),
					// new Number(
					// 	'Dustbin Size:',
					// 	{
					// 		name: 'dustbinSize',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 10,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Dustbin Size (in Ltr)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Minimum of 10L per 70 sq.ft'
					// 	}
					// ),
						new Number(
						'Count of Dustbin:',
						{
							name: 'countOfDustbin',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							onChange:on.countOfDustbinChangeCleanandHygien,
							placeholder: 'Enter the Count of Dustbin',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
							//metainfo:'Minimum of 10L per 70 sq.ft'
						}
					),
				]

			}
		]
	};

	return residentialFacilitiesForm;
}
export function infraForms(data: ResidentialFacility, on: any = {}, modificationInForm:any = {} ) {
	const residentialFacilitiesForm: FormGroupInterface = {
		label: 'Infra Details',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
			//	label: modificationInForm.label,
				formElements: [

			new CheckBox(
				'Type of Construction',
				{
					name: 'typeOfConstructionBuildingOfResidential',
					labelDiv: 4,
					inputDiv: 8,
					required: true,
					checkboxes: [
						{
							label: 'All walls of the residential area are plastered /colored /distempered /whitewashed',
							name: 'wallsOfResidentialWithPlasteredCovered',
						},
						{
							label: 'All Floors of the residential area made up of cement /tile /mosaic /ceramic /hardwood /laminate /marble',
							name: 'floorMadeOfCementedTiled',
						},
						{
							label: 'All walls in residential facility are 100 % covered till the roof',
							name: 'wallsOfResidentialCoveredWithRoof',
						}
					],
					 onChange:on.typeResidential,
					colDivision: 1,
					atLeastChecked: 1,
					readOnly: true
				}
			),
			new Select(
				'Partition Made Of:',
				data.partitionsMadeOf,
				{
					name: 'partitionMadeOf',
					required: true,
					placeholder: 'Select Partition Made Of',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),
			// new Select(
			// 	'Walls of the Residential Facility:',
			// 	data.wallsOfResidentials,
			// 	{
			// 		name: 'wallsOfResidential',
			// 		required: true,
			// 		placeholder: 'Select Walls of th Residential Facility',
			// 		labelDiv: 4,
			// 		inputDiv: 8,
			// 		asyncLoad:true
			// 	}
			// ),
			// new CheckBox(
			// 	'Walls of the Residential Facility:',
			// 	{
			// 		name: 'wallsOfResidential',
			// 		labelDiv: 4,
			// 		inputDiv: 8,
			// 		// required: true,
			// 		checkboxes: [
			// 			{
			// 				label: 'Plastered',
			// 				name: 'plastered',
			// 			},
			// 			/*{
			// 				label: 'Warden',
			// 				name: 'warden',
			// 			},*/
			// 			{
			// 				label: 'Colored',
			// 				name: 'colored',
			// 			},
			// 			{
			// 				label: 'Distempered',
			// 				name: 'distempered',
			// 			},
			// 			{
			// 				label: 'Whitewashed',
			// 				name: 'whitewashed',
			// 			}
			// 		],
			// 		// onChange:on.onCCTVChange,
			// 		colDivision: 2,
			// 		atLeastChecked: 1
			// 	}
			// ),
			// new Select(
			// 	'Floor of the Residential Facility:',
			// 	data.floorOfTheResidentials,
			// 	{
			// 		name: 'floorOfTheResidential',
			// 		required: true,
			// 		placeholder: 'Select Floor of the Residential Facility',
			// 		labelDiv: 4,
			// 		inputDiv: 8,
			// 		asyncLoad:true
			// 	}
			// ),
			// new CheckBox(
			// 	'Floor of the Residential Facility:',
			// 	{
			// 		name: 'floorOfTheResidential',
			// 		labelDiv: 4,
			// 		inputDiv: 8,
			// 		// required: true,
			// 		checkboxes: [
			// 			{
			// 				label: 'Cemented',
			// 				name: 'cemented',
			// 			},
			// 			/*{
			// 				label: 'Warden',
			// 				name: 'warden',
			// 			},*/
			// 			{
			// 				label: 'Tiled',
			// 				name: 'tiled',
			// 			},
			// 			{
			// 				label: 'Mosaic',
			// 				name: 'mosaic',
			// 			},
			// 			{
			// 				label: 'Ceramic',
			// 				name: 'ceramic',
			// 			},
			// 			{
			// 				label: 'Hardwood',
			// 				name: 'hardwood',
			// 			},
			// 			{
			// 				label: 'Laminate',
			// 				name: 'laminate',
			// 			},
			// 			{
			// 				label: 'Marble',
			// 				name: 'marble',
			// 			}
			// 		],
			// 		// onChange:on.onCCTVChange,
			// 		colDivision: 2,
			// 		atLeastChecked: 1
			// 	}
			// ),
			new Select(
				'Availability of Grievance register or a dedicated Email ID for raising grievance:',
				data.areaAvailability || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'emailForGrievance',
					required: true,
					placeholder: 'Select Availability of Grievance register or a dedicated Email ID for raising grievance',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),new Select(
				'Code of Conduct displayed in centre common areas:',
				data.areaAvailability || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'codeOfConductDisplayed',
					required: true,
					placeholder: 'Select Code of Conduct displayed in centre',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),
			// new Select(
			// 							'Meals:',
			// 							data.meals ,
			// 							{
			// 								name: 'meals',
			// 								onChange:on.mealsChange,
			// 								required: true,
			// 								placeholder: 'Select Food Type',
			// 								labelDiv: 4,
			// 								inputDiv: 8,
			// 								asyncLoad:true
			// 							}
			// 						),
			// 						new Select(
			// 							'Menu Food Displayed:',
			// 							data.menuList																																												,
			// 						// 	this.residentialFacilitiesForm.meals ==='Lunch/Dinner'?['Dal/Sambhar/Rasam','Seasonal Vegetable','Rice/pulao','Chappaties/Parathas/Puries']
			// 						// :	this.residentialFacilitiesForm.meals ==='Breakfast'?['Continental as well as Indian foods','Tea/Coffee/Milk/Curd or any other milk product']:[],
			// 							{
			// 								name: 'foodMenu',
			// 								hide:true,
			// 								required: true,
			// 								placeholder: 'Select Food Menu',
			// 								labelDiv: 4,
			// 								inputDiv: 8,
			// 								asyncLoad:true
			// 							}
			// 						),
			new Select(
				'Display of menu & meal timing (Breakfast, Lunch, Dinner & Evening snacks/Tea):',
				data.areaAvailability || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'lunchTime',
					required: true,
					placeholder: 'Select Display of menu & meal timing',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),
			new Text(
				'Remarks',
				{
					name: 'remarks',
					lineAtEnd: false,
					required: false,
					labelDiv: 4,
					inputDiv: 8,
					placeholder: 'Enter Remarks',
					readOnly: true
				}
			),
			new Select(
				'Availability of Toilet:',
				data.areaAvailability  || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'availabilityOfToilet',
					required: true,
					onChange:on.onChangeToilet,
					placeholder: 'Select Availability of Toilet',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad:true,
					readOnly: true
				}
			),
			new Number(
				'Count of Toilet:',
				{
					name: 'countOfToilet',
					required: true,
					hide:true,
					maxFieldLength: 4,
					min: 1,
					validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					placeholder: 'Enter Count of Toilet',
					labelDiv: 4,
					inputDiv: 8,
					metainfo: 'Minimum of 1 Toilet per 10 Trainee',
					onChange: on.countOfToiletChange,
					readOnly: true
				}
			),
			new Select(
				'Availability of Bathroom:',
				data.areaAvailability || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'availabilityOfBathroom',
					required: true,
					onChange:on.onChangeBathRoom,
					placeholder: 'Select Availability of Bathroom',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),
			new Number(
				'Count of Bathroom:',
				{
					name: 'countOfBathroom',
					required: true,
					hide:true,
					maxFieldLength: 4,
					min: 1,
					//validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					placeholder: 'Enter Count of Bathroom',
					labelDiv: 4,
					inputDiv: 8,
					metainfo: 'Minimum of 1 Bathroom per 10 trainee',
					onChange: on.countOfBathroomChange,
					readOnly: true
				}
			),
			new Select(
				'Availability of Bathroom Cum Toilet:',
				data.areaAvailability || [
					{
						name: 'Yes',
						value: true
					},
					{
						name: 'No',
						value: false
					}
				],
				{
					name: 'availabilityOfToiletCumBathRoom',
					required: true,
					onChange:on.onChangeBathRoomCumToilet,
					placeholder: 'Select Availability of Bathroom Cum Toilet',
					labelDiv: 4,
					inputDiv: 8,
					asyncLoad: true,
					readOnly: true
				}
			),
			new Number(
				'Count of Bathroom Cum Toilet:',
				{
					name: 'countOfBathroomCumToilet',
					required: true,
					hide:true,
					maxFieldLength: 4,
					min: 1,
					validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					placeholder: 'Enter Count of Bathroom Cum Toilet',
					labelDiv: 4,
					inputDiv: 8,
					metainfo: 'Minimum of 1 Bathroom cum toilet per 7 trainee',
					onChange: on.countOfToiletCumBathroomChange,
					readOnly: true
				}
			)
				]

			}
		]
	};

	return residentialFacilitiesForm;
}
export function diningAreaForms(data: ResidentialFacility, on: any = {}, modificationInForm:any = {} ) {
	const residentialFacilitiesForm: FormGroupInterface = {
		//label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
			label: 'Dining Area Details',
				formElements: [
					new Select(
						'Availability of Dining Area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfDiningArea',
							onChange:on.availabilityOfDiningAreaChange,
							required: true,
							placeholder: 'Select Availability of Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly: true
						}
					),
					new Number(
						'Area:',
						{
							name: 'diningArea',
							required: true,
							maxFieldLength: 4,
							min: 100,
							hide:true,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area in Sq.Ft',
							labelDiv: 4,
							inputDiv: 8,
							metainfo: 'Minimum Available Area should be more than 100 sq. ft. minimum area per inmate = 2.3 sq. ft',
							onChange: on.diningAreaChange,
							readOnly: true
						}
					),

					new Select(
						'Availability of Ceiling Fan:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfCeilingFanDiningArea',
							required: true,
							placeholder: 'Select Availability of Ceiling Fan',
							onChange:on.cillingFanChangeDiningArea,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad: true,
							readOnly: true
						}
					),
					new Number(
						'Count of Ceiling Fan:',
						{
							name: 'numberOfCeilingFanDiningArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Ceiling Fan in Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							metainfo: '1 ceiling fan per 100 sq. ft',
							readOnly: true
						}
					),
					new Select(
						'Availability of Wall Mounted Fan:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfWallMountedFanDiningArea',
							required: true,
							placeholder: 'Select Availability of Wall Mounted Fan in Dining Area',
							onChange:on.wallFanChangeDiningArea,
						//	onChange:on.availabilityOfDustbinInDiningArea,
							labelDiv: 4,
							inputDiv: 8,
							asyncLoad:true,
							readOnly: true
						}
					),
					new Number(
						'Count of Wall Mounted Fan:',
						{
							name: 'numberOfWallMountedDiningArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 2,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Wall Mounted Fan in Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							 metainfo:'2 wall mounted  fan per 100 sq. ft'
						}
					),
					new Select(
						'Availability of Bulb:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfBulbDiningArea',
							required: true,
							placeholder: 'Select Availability of Bulb in Dining Area',
							onChange:on.bulbChangeDiningArea,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					new Number(
						'Count of Bulb:',
						{
							name: 'numberOfBulbDiningArea',
							//required: true,
						//	hide: true,
							readOnly:true,
							// readOnly:true,

							maxFieldLength: 4,
						//	min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Bulb in Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							// readOnly: true,
							 metainfo:'Minimum requirement as per specifications is 1 bulb per 70 sq. ft.'
						}
					),
					new Select(
						'Availability of Dustbin in Dining Area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfDustinAndDiningArea',
							required: true,
							placeholder: 'Select Availability of Dustbin in Dining Area',
							onChange:on.availabilityOfDustbinInDiningArea,
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
							asyncLoad:true
						}
					),
					new Number(
						'Dustbin Size (in Ltr):',
						{
							name: 'dustbinSizeInDiningArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 10,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dustbin Size (in Ltr)',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo:'Minimum 10 L required in dining area'
						}
					),
				]

			}
		]
	};

	return residentialFacilitiesForm;
}
export function diningAreaRecreationalForms(data: ResidentialFacility, on: any = {}, modificationInForm:any = {} ) {
	const residentialFacilitiesForm: FormGroupInterface = {
		//label: 'Dining Area + Recreational Area Details',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label:'Dining Area + Recreational Area Details',
				formElements: [
					new Select(
						'Availability of Dining Area + Recreational Area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfDiningAreaAndRecreationalArea',
							required: true,
							placeholder: 'Select Availability of Dining Area + Recreational Area',
							onChange:on.availabilityOfDiningAreaAndRecreationalAreaChange,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),

					new Number(
						'Area:',
						{
							name: 'diningAreaAndRecreationalArea',
							required: true,
							maxFieldLength: 4,
							min: 175,
							hide:true,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area + Recreational Area in Sq.Ft',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo: 'Minimum Available Area should be more than 175 sq. ft. minimum area per inmate = 4 sq. ft',
							onChange: on.diningAreaRecreationalChange
						}
					),

					new Select(
						'Availability of Ceiling Fan:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfCeilingFanDiningRecreationArea',
							required: true,
							placeholder: 'Select Availability of Ceiling Fan in Dining Area + Recreational Area',
							onChange:on.ceilingFanDiningRecreational,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					new Number(
						'Count of Ceiling Fan :',
						{
							name: 'numberOfCeilingDiningRecreationArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Ceiling Fan in Dining Area + Recreational Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo:'1 ceiling fan per 100 sq. ft'
						}
					),
					new Select(
						'Availability of Wall Mounted Fan:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfWallMountedFanDiningRecreationalArea',
							required: true,
							placeholder: 'Select Availability of Wall Mounted Fan in Dining Area + Recreational Area',
							// onChange:on.availabilityOfDustbinInDiningArea,
							onChange:on.wallMountedDiningRecreational,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					new Number(
						'Count of Wall Mounted Fan:',
						{
							name: 'numberOfMountedFanDiningRecreationalArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter Count of Wall Mounted Fan in Dining Area + Recreational Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo:'2 wall mounted  fan per 100 sq. ft'
						}
					),
					new Select(
						'Availability of Bulb:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfBulbDiningAreaRecreationalArea',
							required: true,
							placeholder: 'Select Availability of Bulb in Dining Area + Recreational Area',
							onChange:on.availabilityOfbulbDiningRecreational,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							asyncLoad:true
						}
					),
					new Number(
						'Count of Bulb:',
						{
							name: 'numberOfBulbDiningAreaRecreationalArea',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 1,
							// readOnly:true,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Bulb in Dining Area + Recreational Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							 metainfo:'Minimum requirement as per specifications is 1 bulb per 70 sq. ft'
						}
					),
					new Select(
						'Availability of Dustbin in Dining Area and Recreational Area:',
						[
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfDustinAndDiningAreaRecreationalArea',
							required: true,
							placeholder: 'Select Availability of Dustbin in Dining Area and Recreational Area',
							onChange:on.availabilityOfDustbinInDiningAreaRecreationalArea,
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
							asyncLoad:true
						}
					),
					new Number(
						'Count of Dustbin:',
						{
							name: 'countOfdustbinSizeInDiningAreaRecreationalArea',
							required: true,
							hide:true,
							onChange:on.countOfDustbinDiningAreaRecreationalArea,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Count of Dustbin in Dining Area + Recreational Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
							//  metainfo:'2 wall mounted  fan per 100 sq. ft'
						}
					),
					// new Number(
					// 	'Dustbin Size:',
					// 	{
					// 		name: 'dustbinSizeInDiningAreaRecreationalArea',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 10,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Dustbin Size (in Ltr)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Minimum 10 L required in dining area + Recreational Area'
					// 	}
					// ),
					// new Number(
					// 	'Total Area:',
					// 	{
					// 		name: 'totalArea',
					// 		required: true,
					// 		maxFieldLength: 10,
					// 		readOnly:true,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter Total Area(In Sq. Ft)',
					// 		onChange:on.totalAreaChange,
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Area will be auto calculated'
					// 	}
					// ),
					// new Number(
					// 	'Residential Capacity:',
					// 	{
					// 		name: 'capacity',
					// 		required: true,
					// 		// disabled:true,
					// 		readOnly:true,
					// 		maxFieldLength: 5,
					// 		min: 1,
					// 		onChange: on.totalResidentialCapacityChange,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter Total Number of Occupant(s)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Capacity will be auto calculated'
					// 	}
					// ),



				]

			}
		]
	};

	return residentialFacilitiesForm;
}
export function getResidentialForWomen(data: ResidentialFacility, on: any = {}) {
	const residentialFacilitiesForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: 'Residential Facilities for Women',
				formElements: [
					new Select(
						'Residential Area for Women:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availability',
							required: true,
							onChange: on.onWomenAvaliabilityChange,
							placeholder: 'Select if the Residential area available or not',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Total Area:',
						{
							name: 'totalArea',
							required: true,
							maxFieldLength: 10,
							// min: 10,
							// max: 99999,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter Total Area(In Sq. Ft)',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					,
					new Number(
						'Residential Capacity:',
						{
							name: 'capacity',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Residenital Capacity',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new CheckBox(
						'Female Warden:',
						{
							name: 'womenAreaEquipedWith',
							checkboxes: [
								{
									label: '',
									name: 'femaleWarden',
								}
							],
							colDivision: 2,
							 atLeastChecked: 1,
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new CheckBox(
						'Area is equipped with:',
						{
							name: 'equipedWith',
							labelDiv: 4,
							inputDiv: 8,
							// required: true,
							checkboxes: [
								{
									label: 'CCTV camera with Recording Facility',
									name: 'cctvWomen',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Mess',
									name: 'mess',
								},
								{
									label: '24x7 Security',
									name: 'allTimeSecurity',
								},
								{
									label: 'Backup(UPS/GenSet Invertor)',
									name: 'backup',
								}
							],
							onChange:on.onCCTVChange,
							colDivision: 2,
							atLeastChecked: 1,
							readOnly: true
						}
					),
					new Upload('CCTV camera with Recording Facility:', {
						required: true,
						// remove: !fields.addressProof,
						labelDiv: 4,
						inputDiv: 8,
						maxSize:5,
						name: 'cctvCameraDocumentUrl',
						validationType: VALIDATION_TYPE.FILE,
						readOnly: true
						// value: address.addressProof
					}),
					new Number(
						'Distance From Training Centre:',
						{
							name: 'distanceFromTrainingCentre',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Distance From Training Centre',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Type of Construction of the Building of the Residential Facility:',
						data.typeOfConstructionBuilding,
						{
							name: 'typeOfConstructionBuildingOfResidential',
							required: true,
							placeholder: 'Select Type of Construction of the Building of the Residential Facility',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Separate entrances for Male and Female Facility if the hostel is in the same :',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'seperateEntranceForMF',
							required: true,
							placeholder: 'Select Separate entrances for Male and Female Facility if the hostel is in the same',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Availability of Toilet:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfToilet',
							required: true,
							placeholder: 'Select Availability of Toilet',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Availability of Bathroom:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfBathroom',
							required: true,
							placeholder: 'Select Availability of Bathroom',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),


					new Number(
						'Dining Area:',
						{
							name: 'diningArea',
							required: true,
							maxFieldLength: 5,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Dining Area + Recreational Area:',
						{
							name: 'diningAreaAndRecreationalArea',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area + Recreational Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Availability of Grievance register or a dedicated Email ID for raising grievances:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'emailForGrievance',
							required: true,
							placeholder: 'Select Availability of Grievance register or a dedicated Email ID for raising grievances',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),new Select(
						'Code of Conduct displayed in centre common areas:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'codeOfConductDisplayed',
							required: true,
							placeholder: 'Select Code of Conduct displayed in centre common areas',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Breakfast,lunch and dinner timing displayed in the dining area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'lunchTime',
							required: true,
							placeholder: 'Select if Breakfast,lunch and dinner timing displayed in the dining area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Text(
						'Remarks',
						{
							name: 'remarks',
							lineAtEnd: false,
							required: false,
							labelDiv: 4,
							inputDiv: 8,
							placeholder: 'Enter Remarks',
							readOnly: true
						}
					)
				]

			}
		]
	};

	return residentialFacilitiesForm;
}
export function getResidentialForTransgender(data: ResidentialFacility, on: any = {}) {
	const residentialFacilitiesForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: 'Residential Facilities for Transgender',
				formElements: [
					new Select(
						'Residential Area for Transgender:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availability',
							required: true,
							onChange: on.onTransgenderAvaliabilityChange,
							placeholder: 'Select if the Residential area available or not',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Total Area:',
						{
							name: 'totalArea',
							required: true,
							maxFieldLength: 10,
							// min: 10,
							// max: 99999,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter Total Area(In Sq. Ft)',
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
						}
					),
					,
					new Number(
						'Residential Capacity:',
						{
							name: 'capacity',
							required: true,
							maxFieldLength: 5,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Residenital Capacity',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Transgender Warden:',
						data.areaAvailability || [
							{
								name: 'Available',
								value: true
							},
							{
								name: 'Not Available',
								value: false
							}
						],
						{
							name: 'Warden',
							required: true,
							placeholder: 'Select Availability of Male Warden',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new CheckBox(
						'Area is equipped with:',
						{
							name: 'equipedWith',
							labelDiv: 4,
							inputDiv: 8,
							// required: true,
							onChange:on.onCCTVChange,
							checkboxes: [
								{
									label: 'CCTV camera with Recording Facility',
									name: 'cctvTransgender',
								},
								/*{
									label: 'Warden',
									name: 'warden',
								},*/
								{
									label: 'Mess',
									name: 'mess',
								},
								{
									label: '24x7 Security',
									name: 'allTimeSecurity',
								},
								{
									label: 'Backup(UPS/GenSet Invertor)',
									name: 'backup',
								}
							],
							colDivision: 2,
							atLeastChecked: 1
						}
					),
					new Upload('CCTV camera with Recording Facility:', {
						required: true,
						// remove: !fields.addressProof,
						labelDiv: 4,
						inputDiv: 8,
						maxSize:5,
						name: 'cctvCameraDocumentUrl',
						validationType: VALIDATION_TYPE.FILE,readOnly: true
						// value: address.addressProof
					}),
					new Number(
						'Distance From Training Centre:',
						{
							name: 'distanceFromTrainingCentre',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Distance From Training Centre',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Type of Construction of the Building of the Residential Facility:',
						data.typeOfConstructionBuilding ,
						{
							name: 'typeOfConstructionBuildingOfResidential',
							required: true,
							placeholder: 'Select Type of Construction of the Building of the Residential Facility',
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
						}
					),
					new Select(
						'Availability of Toilet:',
						data.areaAvailability || [
							{
								name: 'Available',
								value: true
							},
							{
								name: 'Not Available',
								value: false
							}
						],
						{
							name: 'availabilityOfToilet',
							required: true,
							placeholder: 'Select Availability of Toilet',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Availability of Bathroom:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'availabilityOfBathroom',
							required: true,
							placeholder: 'Select Availability of Bathroom',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Dining Area:',
						{
							name: 'diningArea',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Dining Area + recreational Area:',
						{
							name: 'diningAreaAndRecreationalArea',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dining Area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Availability of Grievance register or a dedicated Email ID for raising grievance:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'emailForGrievance',
							required: true,
							placeholder: 'Select Availability of Grievance register or a dedicated Email ID for raising grievance',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),new Select(
						'Code of Conduct displayed in centre common areas:',
						data.areaAvailability || [
							{
								name: 'Available',
								value: true
							},
							{
								name: 'Not Available',
								value: false
							}
						],
						{
							name: 'codeOfConductDisplayed',
							required: true,
							placeholder: 'Select Code of Conduct displayed in centre common areas',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Food Type:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'meals',
							required: true,
							placeholder: 'Select Food Type',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Menu Food Displayed:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'foodMenu',
							required: true,
							placeholder: 'Select Food Menu',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Select(
						'Breakfast,lunch and dinner timing displayed in the dining area:',
						data.areaAvailability || [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],
						{
							name: 'lunchTime',
							required: true,
							placeholder: 'Select Breakfast,lunch and dinner timing displayed in the dining area',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Text(
						'Remarks',
						{
							name: 'remarks',
							lineAtEnd: false,
							required: false,
							labelDiv: 4,
							inputDiv: 8,
							placeholder: 'Enter Remarks',
							readOnly: true
						}
					)
				]

			}
		]
	};

	return residentialFacilitiesForm;
}

export function addRoomForm(data: IOptionRequired = {}, on: any = {}) {
	const roomForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.WITHOUT_STYLE,
		forms: [
			{
				label: '',
				formElements: [
						new Number(
						'Room Area (in Sq.Ft):',
						{
							name: 'roomArea',
							onBlur:on.roomAreaChange,
							required: true,
							maxFieldLength: 4,
							min: 70,
							minFieldLength:5,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Room Area (in Sq.Ft)',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true
						}
					),
					new Number(
						'Occupants of Room:',
						{
							name: 'capacity',
							required: true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Occupants of Room',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo:'Minimum space requirement per occupant in each room is 35 sq.ft.'
						}
					),
					new Number(
						'Ceiling Height (in ft):',
						{
							name: 'ceilingHeight',
							required: true,
							maxFieldLength: 4,
							min: 9,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Ceiling Height (in ft)',
							labelDiv: 4,
							readOnly: true,
							inputDiv: 8,
							metainfo:'Minimum Ceiling Height to be 9 ft.'
						}
					)
					,
					new Select(
						'Availability of Window for Cross Ventilation:',
						 [
							{
								name: 'Yes',
								value: true
							},
							{
								name: 'No',
								value: false
							}
						],	{
							name: 'availabilityOfWindowCrossVentilation',
							required: true,
							placeholder: 'Select Availability of Window for Cross Ventilation',
							onChange:on.availabilityOfWindowChange,
							labelDiv: 4,
							 inputDiv: 8,
							 readOnly: true
						}),
						new Select(
							'Windows with Doors and Working Locks:',
							data.areaAvailability || [
								{
									name: 'Yes',
									value: true
								},
								{
									name: 'No',
									value: false
								}
							],	{
								name: 'windowDoorWorkingLocks',
								required: true,
								hide:true,
								placeholder: 'Select Window with Doors with Working Locks',
								labelDiv: 4,
								inputDiv: 8,
								readOnly: true
							}),
					// 		new Number(
					// 			'Window Size:',
					// 			{
					// 				row: false,
					// 				align: 6,
					// 				name: 'windowSize',
					// 				required: true,
					// 				hide:false,
					// 				maxFieldLength: 5,
					// 				min: 6,
					// 				validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 				placeholder: 'Enter the Window Size(in ft)',
					// 				labelDiv: 4,
					// 				inputDiv: 8,
					// 				metainfo:'Minimum of 3ft * 2ft.(H*W)'
					// 			}
					// ),
								new Number(
								'Window Height (in ft):',
								{
								//	row: false,
									//align: 4,
									name: 'windowHeight',
									required: true,
									hide:false,
									maxFieldLength: 4,
									min: 3,
									validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
									placeholder: 'Enter the Window Height (in ft)',
									labelDiv: 4,
									inputDiv: 8,
									readOnly: true,
									metainfo:'Minimum Window Height to be 3 ft.'
								}
					),
					new Number(
						'Window Width (in ft):',
						{
						//	row: false,
						//	align: 4,
							name: 'windowWidth',
							required: true,
							hide:false,
							maxFieldLength: 4,
							min: 2,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Window Width (in ft)',
							labelDiv: 4,
							inputDiv: 8,
							readOnly: true,
							metainfo:'Minimum Window Width to be 2 ft.'
						}
					),
						new Select(
							'Availability of Door at the Entrance of the Room:',
							data.areaAvailability || [
								{
									name: 'Yes',
									value: true
								},
								{
									name: 'No',
									value: false
								}
							],
							{
								name: 'availabilityOfDoorAtEntrance',
								required: true,
								placeholder: 'Select Availability of Door at the Entrance of the Room',
								labelDiv: 4,
								inputDiv: 8,
								readOnly: true,
								onChange:on.availabilityOfDoorChange,
							}),
							new Select(
								'Doors with Working Locks:',
								data.areaAvailability || [
									{
										name: 'Yes',
										value: true
									},
									{
										name: 'No',
										value: false
									}
								],	{
									name: 'doorWorkingLocks',
									required: true,
									hide:true,
									placeholder: 'Select Window with Doors with Working Locks',
									labelDiv: 4,
									readOnly: true,
									inputDiv: 8,
								}),
								// new Number(
								// 	'Door Size:',
								// 	{
								// 		name: 'doorSize',
								// 		required: true,
								// 		maxFieldLength: 5,
								// 		min: 18.4,
								// 		hide:true,
								// 		validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
								// 		placeholder: 'Enter the Window Size(in ft)',
								// 		labelDiv: 4,
								// 		inputDiv: 8,
								// 		metainfo:'Minimum of 6ft.6in * 2ft.6in(H*W)'
								// 	}
								// ),
								new Text(
									'Door Height (in ft):',
									{
									//	row: false,
									//	align: 6,
										name: 'doorHeight',
										required: true,
										hide:false,
										maxFieldLength: 4,
										min: 6.6,
										validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
										placeholder: 'Enter the Door Height (in ft)',
										labelDiv: 4,
										inputDiv: 8,
										readOnly: true,
										metainfo:'Minimum Door Height to be 6 ft.6 in'
									}
						),
						new Text(
							'Door Width (in ft):',
							{
							//	row: false,
							//	align: 6,
								name: 'doorWidth',
								required: true,
								hide:false,
								maxFieldLength: 4,
								min: 2.6,
								validationType: VALIDATION_TYPE.DECIMAL_NUMBER,
								placeholder: 'Enter the Door Width (in ft)',
								labelDiv: 4,
								readOnly: true,
								inputDiv: 8,
								metainfo:'Minimum Door Width to be 2 ft.6 in'
								//metainfo:'Minimum of 3ft * 2ft.(H*W)'
							}
						),
						new Select(
							'Availability of AC:',
							data.areaAvailability || [
								{
									name: 'Yes',
									value: true
								},
								{
									name: 'No',
									value: false
								}
							],
							{
								name: 'availabilityOfAC',
								required: true,
								placeholder: 'Select Availability of AC',
								labelDiv: 4,
								inputDiv: 8,
								readOnly: true,
								onChange:on.availabilityOfAcChange
							}),
							new Number(
								'Capacity of AC in Ton (ton):',
								{
									name: 'numberOfTonsAC',
									required: true,
									maxFieldLength: 4,
									min: 1,
									validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
									placeholder: 'Enter the Capacity of AC in Ton',
									labelDiv: 4,
									inputDiv: 8,
									readOnly: true,
									metainfo:'Minimum of 1 Ton/80-120 Sq.Ft'
								}
							),
							new CheckBox(

								'Area Equipped with:',
								{
									// lineAtStart: true,
									// lineAtEnd: true,
									checkboxes: [
										// {
										// 	label: 'cot',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.securityGaurds,
										// 	name: 'cot'
										// },
										// {
										// 	label: 'Matress',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.greeneryInTheSurrounding,
										// 	name: 'matress'
										// },
										// {
										// 	label: 'Pillow',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.adequatePowerBackup,
										// 	name: 'pillow'
										// },
										// {
										// 	label: 'Trunk with lock',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
										// 	name: 'trunkWithLock'
										// },
										// {
										// 	label: 'Cupboard/Almirah with locking Arrangement',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
										// 	name: 'cupboardLockingArrangement'
										// }
										// ,
										{
											label: 'Availability of light bulb in the room area as per specifications(1 bulb per 70 sq. ft)',
											// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
											name: 'ledCFLIncandentLight'
										},
										{
											label: 'Ceiling Fan',
											// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
											name: 'ceilingFan'
										},
										{
											label: 'Wall Mounted Fan',
											// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
											name: 'wallMountedFan'
										},
										{
											label: 'Plug Point',
											// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
											name: 'plugPoint'
										},
										// {
										// 	label: 'Availability of dedicated housekeeping staff at the Residential Facility',
										// 	//  value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
										// 	name: 'availabilityOfDedicatedHousekeepingStaff'
										// },
										// {
										// 	label: 'Availability of power backup covering basic facilities such as lights and Fans',
										// 	// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
										// 	name: 'powerBackUp'
										// },
										{
											label: 'Availability of dustbin',
											// value: savedFormData.trainingCentreFacilities && savedFormData.trainingCentreFacilities.isTrainingCentreFunctional,
											name: 'dustbin'
										}
									],
									// atLeastChecked: 2,
									colDivision: 2,
									required: true,
									readOnly: true,
									name: 'areaEquippedWith',
									onChange:on.areaEquippedWithRoomChange,
									// value: savedFormData.trainingCentreFacilities,
									labelDiv: 4,
									inputDiv: 8,
								}
					),
					// new Number(
					// 	'Cot Size:',
					// 	{
					// 		name: 'cotSize',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 18,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Cot Size(in ft)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Minimum of 6ft * 3ft.(L*W)'
					// 	}
					// ),
			// 		new Number(
			// 			'Cot Height:',
			// 			{
			// 			//	row: false,
			// 			//	align: 6,
			// 				name: 'cotHeight',
			// 				required: true,
			// 				hide:false,
			// 				maxFieldLength: 5,
			// 				min: 3,
			// 				validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
			// 				placeholder: 'Enter the Cot Height(in ft)',
			// 				labelDiv: 4,
			// 				inputDiv: 8,
			// 				//metainfo:'Minimum of 3ft * 2ft.(H*W)'
			// 			}
			// ),
			// new Number(
			// 	'Cot Width:',
			// 	{
			// 	//	row: false,
			// 	//	align: 6,
			// 		name: 'cotWidth',
			// 		required: true,
			// 		hide:false,
			// 		maxFieldLength: 5,
			// 		min: 2,
			// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
			// 		placeholder: 'Enter the Cot Width(in ft)',
			// 		labelDiv: 4,
			// 		inputDiv: 8,
			// 		//metainfo:'Minimum of 3ft * 2ft.(H*W)'
			// 	}
			// ),
					// new Select(
					// 	'Frame of Cot:',
					// 	[
					// 		'Wooden',
					// 		'Metal'
					// 	],	{
					// 		name: 'frameOfCot',
					// 		hide:true,
					// 		required: true,
					// 		placeholder: 'Select Frame of Cot',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 	}),
						// new Select(
						// 	'Type Of Mattress:',
						// [
						// 	'Cotton',
						// 	'Foam',
						// 	'Fiber'
						// 	],	{
						// 		name: 'matressType',
						// 		hide:true,
						// 		required: true,
						// 		onChange:on.matressChange,
						// 		placeholder: 'Select Type Of Mattress',
						// 		labelDiv: 4,
						// 		inputDiv: 8,
						// 	}),
					// 		new Number(
					// 			'Mattress Size:',
					// 			{
					// 				name: 'matressSize',
					// 				required: true,
					// 				hide:true,
					// 				maxFieldLength: 5,
					// 				min: 3,
					// 				validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 				placeholder: 'Enter the Mattress Size(in thickness)',
					// 				labelDiv: 4,
					// 				inputDiv: 8,
					// 			}
					// ),
					// new Number(
					// 	'Trunk Size:',
					// 	{
					// 		name: 'trunkSize',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 1,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Trunk Size(in Sq.in)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Mininum of 6480 Sq.in'
					// 	}
					// ),
					// 	new Number(
					// 	'Number of Trunk:',
					// 	{
					// 		name: 'noOfTrunk',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 1,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Number of Trunk',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 	}
					// ),
					// new Number(
					// 	'Volume of Cupboard/Almirah:',
					// 	{
					// 		name: 'volumeOfCupboard',
					// 		required: true,
					// 		hide:true,
					// 		maxFieldLength: 5,
					// 		min: 1,
					// 		validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 		placeholder: 'Enter the Volume of Cupboard/Almirah(in Sq.in)',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 		metainfo:'Mininum of 6480 Sq.in or 20% deviations'
					// 	}
					// ),
					// new Number(
					// 		'Number of Cupboard/Almirah:',
					// 		{
					// 			name: 'numberOfCupboardAndAlmirah',
					// 			required: true,
					// 			hide:true,
					// 			maxFieldLength: 5,
					// 			min: 1,
					// 			validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 			placeholder: 'Enter the Number of Cupboard/Almirah(in Sq.in)',
					// 			labelDiv: 4,
					// 			inputDiv: 8
					// 		}
					// 	),
					new Number(
						'Number of Bulb:',
						{
							name: 'numberOfbulb',
							required: true,
							hide: true,
							readOnly:true,
							maxFieldLength: 4,
							min: 1,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Number of Bulb',
							labelDiv: 4,
							inputDiv: 8,
							metainfo:'Minimum requirement as per specifications is 1 bulb per 70 sq. ft.'
						}
					),
					// new Select(
					// 	'Power:',
					// 	[
					// 		'LED(Minimum of 12W)',
					// 		'CFL(Minimum of 18W)',
					// 		'Incandescent(Minimum of 75W)'
					// 	],	{
					// 		name: 'power',
					// 		hide:true,
					// 		required: true,
					// 		placeholder: 'Select Power',
					// 		labelDiv: 4,
					// 		inputDiv: 8,
					// 	}),
						// new Select(
						// 	'Ceilling Fan:',
						// 	[
						// 		'2 Wall mounted Fan per 100 sq ft',
						// 		'1 Celling Fan per 100 sq ft'
						// 	],	{
						// 		name: 'typeOfCeillingFan',
						// 		hide:true,
						// 		required: true,
						// 		placeholder: 'Select Ceilling Fan',
						// 		labelDiv: 4,
						// 		inputDiv: 8,
						// 	}),
						new Number(
							'Number of Ceilling Fan:',
							{
								name: 'numberOfCeillingFan',
								required: true,
								hide:true,
								maxFieldLength: 4,
								min: 1,
								readOnly: true,
								validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
								placeholder: 'Enter the Number of Ceilling Fan',
								labelDiv: 4,
								inputDiv: 8,
								metainfo:'1 Celling Fan per 100 sq ft'
							}
					),
					new Number(
						'Number of Wall Mounted Fan:',
						{
							name: 'numberOfWallMountedFan',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 2,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Number of Wall Mounted Fan',
							labelDiv: 4,
							inputDiv: 8,
							metainfo: '2 Wall mounted Fan per 100 sq ft',
							readOnly: true
						}
					),
					new Number(
						'Dustbin Size (in Ltr):',
						{
							name: 'dustbinSize',
							required: true,
							hide:true,
							maxFieldLength: 4,
							min: 5,
							validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
							placeholder: 'Enter the Dustbin Size (in Ltr)',
							labelDiv: 4,
							inputDiv: 8,
							metainfo: 'Minimum of 5L-10L/70 sq.ft.',
							readOnly: true
						}
					),
							new Number(
								'Number of Plug Points:',
								{
									name: 'numberOfPlugPoint',
									required: true,
									hide:true,
									maxFieldLength: 4,
									min: 2,
									validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
									placeholder: 'Enter the Number of Plug Points',
									labelDiv: 4,
									inputDiv: 8,
									metainfo: 'Mininum of 2  Plug Points/70sq.ft'
									, readOnly: true
								}
							),

				],


			}
		]
	};

	return roomForm;
}



